import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectPrestartItemsPage } from './select-prestart-items';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    SelectPrestartItemsPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectPrestartItemsPage),
    HttpClientModule
  ],
})
export class SelectPrestartItemsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-prestart-items/select-prestart-items.module.ts